var path = 'areas/shared/views/selector/match-tag.html';
var html = "<span ng-if=\"$item.Name == null\" class=deleted uib-tooltip=\"The tag referenced by this record ({{$item}}) no longer exists and should be removed before saving. Please let Octopus support know so that we can prevent this from happening in future.\"><i class=\"fa fa-warning\"></i> Missing</span> <span ng-if=\"$item.Name != null\" set-select-match-color uib-tooltip={{$item.Description}}>{{$item.Name}}</span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/selector/match-tag.html
// module id = 6100685093996544
// module chunks = 1